var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"spinner-container flex content-center justify-center flex-wrap"},[_c('div',{staticClass:"spinner ease-linear rounded-full border-gray-200",style:(_vm.style)})])
}
var staticRenderFns = []

export { render, staticRenderFns }